import { type ReactElement, type PropsWithChildren } from 'react'
import { Page } from '@components'

type Props = PropsWithChildren
export const ProgramPageContainer = ({ children }: Props): ReactElement => {
  return (
    <Page className='h-[calc(100vh-(85px+var(--app-shell-header-offset,0rem)+var(--app-shell-padding)*2))]'>
      {children}
    </Page>
  )
}
